var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBecasPreferenciales = function SvgBecasPreferenciales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#becas-preferenciales_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.62 26.13c-10.54 0-19.12 8.58-19.12 19.12 0 10.54 8.58 19.12 19.12 19.12 10.54 0 19.12-8.58 19.12-19.12 0-10.54-8.58-19.12-19.12-19.12Zm0 33.99c-8.2 0-14.87-6.67-14.87-14.87s6.67-14.87 14.87-14.87 14.87 6.67 14.87 14.87-6.67 14.87-14.87 14.87ZM23.37 57.99h-8.5c-1.17 0-2.12-.95-2.12-2.12v-9.74l2.75 2.75c.41.41.96.62 1.5.62s1.09-.21 1.5-.62c.83-.83.83-2.17 0-3l-6.37-6.37a2.13 2.13 0 0 0-3.01 0l-6.37 6.37c-.83.83-.83 2.17 0 3 .83.83 2.17.83 3 0l2.75-2.75v9.74c0 3.52 2.86 6.37 6.37 6.37h8.5a2.121 2.121 0 0 0 0-4.24M40.37 7h8.5c1.17 0 2.12.95 2.12 2.12v9.74l-2.75-2.75c-.83-.83-2.17-.83-3 0-.83.83-.83 2.17 0 3l6.37 6.37c.41.41.96.62 1.5.62s1.09-.21 1.5-.62l6.37-6.37c.83-.83.83-2.17 0-3-.83-.83-2.17-.83-3 0l-2.75 2.75V9.12c0-3.52-2.86-6.37-6.37-6.37h-8.5a2.121 2.121 0 0 0 0 4.24",
    fill: "#03F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.85 40.29h7.08a2.121 2.121 0 0 0 0-4.24h-3.19v-1.42a2.121 2.121 0 0 0-4.24 0v1.45c-2.96.19-5.31 2.63-5.31 5.63s2.54 5.67 5.67 5.67h3.54a1.419 1.419 0 1 1 0 2.84h-7.08a2.121 2.121 0 0 0 0 4.24h3.19v1.42a2.121 2.121 0 0 0 4.24 0v-1.45c2.96-.19 5.31-2.63 5.31-5.63s-2.54-5.67-5.67-5.67h-3.54c-.78 0-1.42-.63-1.42-1.42 0-.79.64-1.41 1.42-1.41",
    fill: "#03F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.99 17.63c0 9.39-7.61 17-17 17S0 27.01 0 17.63c0-9.38 7.61-17 17-17s17 7.61 17 17",
    fill: "#EB3D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "becas-preferenciales_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .63)",
    d: "M0 0h63.74v63.74H0z"
  })))));
};
export default SvgBecasPreferenciales;